<div class="px-4 mt-24 min-h-screen">
  <div class="max-w-md w-full mx-auto space-y-6">
    <!-- Instructor Notice -->
    @if (registerAsInstructor) {
    <div class="daisy-alert daisy-alert-info">
      <div>
        <h4 class="font-bold">
          You are currently registering as an instructor.
        </h4>
        <a routerLink="/auth/register" class="text-info hover:text-info-focus">
          Click here to register as a student
        </a>
      </div>
    </div>
    }

    <!-- Identify User -->
    @if (currentStep === 'identify') {
    <!-- Header -->
    <div class="text-center">
      <h1 class="text-4xl font-bold text-base-content">Let's Get Started</h1>
      <p class="text-base-content/70 mt-2">
        Create your account in a few steps.
      </p>
    </div>

    <!-- Error Alert -->
    @if (error) {
    <div class="daisy-alert daisy-alert-error">
      <i class="fa-solid fa-circle-exclamation"></i>
      <span>{{ error }}</span>
    </div>
    }

    <div class="daisy-card bg-base-100 shadow-xl">
      <div class="daisy-card-body">
        <form [formGroup]="identifyForm" class="space-y-4">
          <div class="daisy-form-control w-full">
            <label class="daisy-label">
              <span class="daisy-label-text"
                >Email Address or Mobile Number</span
              >
            </label>
            <input
              type="text"
              formControlName="username"
              placeholder="Email Address or Mobile Number"
              class="daisy-input daisy-input-bordered w-full"
              [ngClass]="{
                'daisy-input-error':
                  isFieldInvalid(identifyForm, 'username') &&
                  (hasFieldError(identifyForm, 'username', 'required') ||
                    hasFieldError(identifyForm, 'username', 'emailPhone'))
              }"
            />
            @if ( isFieldInvalid(identifyForm, 'username') &&
            (hasFieldError(identifyForm, 'username', 'required') ||
            hasFieldError(identifyForm, 'username', 'emailPhone')) ) {
            <div class="daisy-label mt-1">
              @if (hasFieldError(identifyForm, 'username', 'required')) {
              <span class="daisy-label-text-alt text-error">
                Username is required
              </span>
              } @if (hasFieldError(identifyForm, 'username', 'emailPhone')) {
              <span class="daisy-label-text-alt text-error">
                Username should be valid email or mobile number
              </span>
              }
            </div>
            }
          </div>

          <div class="daisy-form-control w-full">
            <label class="daisy-label cursor-pointer justify-start gap-3">
              <input
                type="checkbox"
                formControlName="agree"
                class="daisy-checkbox daisy-checkbox-primary"
              />
              <span class="daisy-label-text text-sm">
                I agree to the <a routerLink="/terms" target="_blank" class="text-primary hover:underline">Terms and Conditions</a> and <a routerLink="/privacy" target="_blank" class="text-primary hover:underline">Privacy Policy</a>, including the processing of my personal data as described therein.
              </span>
            </label>
            @if (isFieldInvalid(identifyForm, 'agree') && hasFieldError(identifyForm, 'agree', 'required')) {
            <div class="daisy-label mt-1">
              <span class="daisy-label-text-alt text-error">
                You must agree to the Terms & Conditions and Privacy Policy to continue.
              </span>
            </div>
            }
          </div>

          <button
            (click)="submitIdentifyForm()"
            class="daisy-btn daisy-btn-primary w-full mt-2"
            [disabled]="identifyForm.invalid || isLoading"
          >
            @if (isLoading) {
            <span class="daisy-loading daisy-loading-spinner daisy-loading-sm"></span>
            } @else { Send verification code }
          </button>

          <!-- Google Sign-In Button -->
          @if (isGoogleLoginEnabled) {
            <div class="daisy-divider">OR</div>
            <div class="relative w-full" [ngClass]="{ 'pointer-events-none opacity-50': !identifyForm.value.agree }">
              @if (isGoogleLoading) {
              <button type="button" class="daisy-btn daisy-btn-outline daisy-btn-primary w-full gap-2 pointer-events-none">
                <span class="daisy-loading daisy-loading-spinner daisy-loading-sm text-primary"></span>
                <span>Authenticating with Google...</span>
              </button>
              } @else {
              <div
                id="google-signup-button"
                class="w-full flex justify-center"
              ></div>
              }
            </div>
          }

          <div class="text-center text-sm text-base-content/70">
            Already have an account?
            <a
              routerLink="/auth/login"
              class="text-primary hover:text-primary-focus transition-colors ml-1"
            >
              Log In
            </a>
          </div>
        </form>
      </div>
    </div>
    }

    <!-- Verify OTP with shared component -->
    @if (currentStep === 'verify') {
    <div class="space-y-3">
      <black-verify-otp
        [username]="identifyForm.value.username"
        (otpReady)="submitVerifyForm($event.code)"
        [sendCodeOnInit]="false"
        (sendCodeEvent)="submitIdentifyForm()"
      ></black-verify-otp>
    </div>
    }

    <!-- Complete Registration -->
    @if (currentStep === 'complete') {

    <!-- Header -->
    <div class="text-center">
      <h1 class="text-4xl font-bold text-base-content">Finish setting up</h1>
      <p class="text-base-content/70 mt-2">
        Add your details and choose a password.
      </p>
    </div>

    <div class="daisy-card bg-base-100 shadow-xl">
      <div class="daisy-card-body">
        <form [formGroup]="completeForm" class="space-y-4">
          <div class="daisy-form-control w-full">
            <label class="daisy-label">
              <span class="daisy-label-text">First Name</span>
            </label>
            <input
              type="text"
              formControlName="first_name"
              name="firstname"
              placeholder="First Name"
              class="daisy-input daisy-input-bordered w-full"
              [ngClass]="{
                'daisy-input-error':
                  isFieldInvalid(completeForm, 'first_name') &&
                  hasFieldError(completeForm, 'first_name', 'required')
              }"
            />
            @if ( isFieldInvalid(completeForm, 'first_name') &&
            hasFieldError(completeForm, 'first_name', 'required') ) {
            <div class="daisy-label mt-1">
              @if (hasFieldError(completeForm, 'first_name', 'required')) {
              <span class="daisy-label-text-alt text-error">
                First Name is required
              </span>
              }
            </div>
            }
          </div>

          <div class="daisy-form-control w-full">
            <label class="daisy-label">
              <span class="daisy-label-text">Last Name</span>
            </label>
            <input
              type="text"
              formControlName="last_name"
              name="lastname"
              placeholder="Last Name"
              class="daisy-input daisy-input-bordered w-full"
              [ngClass]="{
                'daisy-input-error':
                  isFieldInvalid(completeForm, 'last_name') &&
                  hasFieldError(completeForm, 'last_name', 'required')
              }"
            />
            @if ( isFieldInvalid(completeForm, 'last_name') &&
            hasFieldError(completeForm, 'last_name', 'required') ) {
            <div class="daisy-label mt-1">
              @if (hasFieldError(completeForm, 'last_name', 'required')) {
              <span class="daisy-label-text-alt text-error">
                Last Name is required
              </span>
              }
            </div>
            }
          </div>

          <div class="daisy-form-control w-full">
            <label class="daisy-label">
              <span class="daisy-label-text">Date of Birth</span>
            </label>
            <input
              type="date"
              formControlName="dateOfBirth"
              class="daisy-input daisy-input-bordered w-full"
              [ngClass]="{
                'daisy-input-error':
                  isFieldInvalid(completeForm, 'dateOfBirth') &&
                  (hasFieldError(completeForm, 'dateOfBirth', 'required') ||
                    hasFieldError(completeForm, 'dateOfBirth', 'instructorUnder16') ||
                    (registerAsInstructor && isUnder16))
              }"
            />
            @if ( isFieldInvalid(completeForm, 'dateOfBirth') &&
            (hasFieldError(completeForm, 'dateOfBirth', 'required') ||
              hasFieldError(completeForm, 'dateOfBirth', 'instructorUnder16') ||
              (registerAsInstructor && isUnder16)) ) {
            <div class="daisy-label mt-1">
              @if (hasFieldError(completeForm, 'dateOfBirth', 'required')) {
              <span class="daisy-label-text-alt text-error">
                Date of Birth is required
              </span>
              } @else if (hasFieldError(completeForm, 'dateOfBirth', 'instructorUnder16') || (registerAsInstructor && isUnder16)) {
              <span class="daisy-label-text-alt text-error">
                Instructors must be at least 16 years of age
              </span>
              }
            </div>
            }
          </div>

          @if (!registerAsInstructor && isUnder16) {
          <div class="daisy-form-control w-full">
            <label class="daisy-label">
              <span class="daisy-label-text">Parent/Guardian Email</span>
            </label>
            <input
              type="email"
              formControlName="parentEmail"
              placeholder="Parent/Guardian Email Address"
              class="daisy-input daisy-input-bordered w-full"
              [ngClass]="{
                'daisy-input-error':
                  isFieldInvalid(completeForm, 'parentEmail') &&
                  (hasFieldError(completeForm, 'parentEmail', 'required') || hasFieldError(completeForm, 'parentEmail', 'email'))
              }"
            />
            @if ( isFieldInvalid(completeForm, 'parentEmail') ) {
            <div class="daisy-label mt-1">
              @if (hasFieldError(completeForm, 'parentEmail', 'required')) {
              <span class="daisy-label-text-alt text-error">
                Parent/Guardian Email is required for users under 16
              </span>
              } @if (hasFieldError(completeForm, 'parentEmail', 'email')) {
              <span class="daisy-label-text-alt text-error">
                Please enter a valid email address
              </span>
              }
            </div>
            }
          </div>
          }

          <div class="daisy-form-control w-full">
            <label class="daisy-label">
              <span class="daisy-label-text">Password</span>
            </label>
            <div class="relative">
              <input
                [type]="showPassword ? 'text' : 'password'"
                name="password"
                formControlName="password"
                placeholder="Password"
                class="daisy-input daisy-input-bordered w-full pr-10"
                [ngClass]="{
                  'daisy-input-error':
                    isFieldInvalid(completeForm, 'password') &&
                    hasFieldError(completeForm, 'password', 'required')
                }"
              />
              <button
                type="button"
                (click)="showPassword = !showPassword"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-base-content/50 hover:text-base-content focus:outline-none"
                [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
              >
                <i [class]="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
              </button>
            </div>
            @if ( isFieldInvalid(completeForm, 'password') &&
            (hasFieldError(completeForm, 'password', 'required') ||
            hasFieldError(completeForm, 'password', 'pattern')) ) {
            <div class="daisy-label mt-1">
              @if (hasFieldError(completeForm, 'password', 'required')) {
              <span class="daisy-label-text-alt text-error">
                Password is required
              </span>
              } @if (hasFieldError(completeForm, 'password', 'pattern')) {
              <div
                class="daisy-alert daisy-alert-warning mt-2 text-sm text-left"
              >
                <div>
                  Your password should contain:
                  <ul class="list-disc list-inside mt-1">
                    <li>At least one lowercase character</li>
                    <li>At least one uppercase character</li>
                    <li>At least one digit</li>
                    <li>Minimum length of 8 characters</li>
                  </ul>
                </div>
              </div>
              }
            </div>
            }
          </div>

          <div class="daisy-form-control w-full">
            <label class="daisy-label">
              <span class="daisy-label-text">Confirm Password</span>
            </label>
            <div class="relative">
              <input
                [type]="showConfirmPassword ? 'text' : 'password'"
                name="confirm_password"
                formControlName="confirm_password"
                placeholder="Confirm Password"
                class="daisy-input daisy-input-bordered w-full pr-10"
                [ngClass]="{
                  'daisy-input-error':
                    isFieldInvalid(completeForm, 'confirm_password') &&
                    (hasFieldError(
                      completeForm,
                      'confirm_password',
                      'required'
                    ) ||
                      hasFormError(completeForm, 'confirmPasswordInvalid'))
                }"
              />
              <button
                type="button"
                (click)="showConfirmPassword = !showConfirmPassword"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-base-content/50 hover:text-base-content focus:outline-none"
                [attr.aria-label]="showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'"
              >
                <i [class]="showConfirmPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
              </button>
            </div>
            @if ( isFieldInvalid(completeForm, 'confirm_password') &&
            (hasFieldError(completeForm, 'confirm_password', 'required') ||
            hasFormError(completeForm, 'confirmPasswordInvalid')) ) {
            <div class="daisy-label mt-1">
              @if ( hasFieldError(completeForm, 'confirm_password', 'required')
              ) {
              <span class="daisy-label-text-alt text-error">
                Confirm Password is required
              </span>
              } @if ( hasFormError(completeForm, 'confirmPasswordInvalid') &&
              !hasFieldError(completeForm, 'confirm_password', 'required') ) {
              <span class="daisy-label-text-alt text-error">
                Passwords must match
              </span>
              }
            </div>
            }
          </div>

          <div class="daisy-form-control w-full">
            <label class="daisy-label cursor-pointer justify-start gap-3">
              <input
                type="checkbox"
                formControlName="agree"
                class="daisy-checkbox daisy-checkbox-primary"
              />
              <span class="daisy-label-text text-sm">
                I agree to the <a routerLink="/terms" target="_blank" class="text-primary hover:underline">Terms and Conditions</a> and <a routerLink="/privacy" target="_blank" class="text-primary hover:underline">Privacy Policy</a>, including the processing of my personal data as described therein.
              </span>
            </label>
            @if (isFieldInvalid(completeForm, 'agree') && hasFieldError(completeForm, 'agree', 'required')) {
            <div class="daisy-label mt-1">
              <span class="daisy-label-text-alt text-error">
                You must agree to the Terms & Conditions and Privacy Policy to continue.
              </span>
            </div>
            }
          </div>

          <button
            (click)="submitCompleteForm()"
            class="daisy-btn daisy-btn-primary w-full mt-2"
            [disabled]="completeForm.invalid || isLoading"
          >
            @if (isLoading) {
            <span class="daisy-loading daisy-loading-spinner daisy-loading-sm"></span>
            } @else { Create Account }
          </button>

          <div class="text-center text-sm text-base-content/70">
            Already have an account?
            <a
              routerLink="/auth/login"
              class="text-primary hover:text-primary-focus transition-colors ml-1"
            >
              Log In
            </a>
          </div>
        </form>
      </div>
    </div>
    }

    <!-- Google Onboarding Modal -->
    @if (showGoogleOnboarding) {
    <div class="daisy-modal daisy-modal-open">
      <div class="daisy-modal-box">
        <h3 class="font-bold text-lg text-base-content">Complete Google Sign-Up</h3>
        <p class="py-2 text-sm text-base-content/70">
          Please enter your Date of Birth to complete your registration.
        </p>

        <form [formGroup]="googleOnboardingForm" (ngSubmit)="submitGoogleOnboarding()" class="space-y-4 mt-2">
          <div class="daisy-form-control w-full">
            <label class="daisy-label">
              <span class="daisy-label-text font-medium">Date of Birth</span>
            </label>
            <input
              type="date"
              formControlName="dateOfBirth"
              class="daisy-input daisy-input-bordered w-full"
              [ngClass]="{
                'daisy-input-error':
                  isFieldInvalid(googleOnboardingForm, 'dateOfBirth') &&
                  (hasFieldError(googleOnboardingForm, 'dateOfBirth', 'required') ||
                    hasFieldError(googleOnboardingForm, 'dateOfBirth', 'instructorUnder16') ||
                    (googleRole === 'INSTRUCTOR' && isGoogleUnder16))
              }"
            />
            @if (isFieldInvalid(googleOnboardingForm, 'dateOfBirth') && (hasFieldError(googleOnboardingForm, 'dateOfBirth', 'required') || hasFieldError(googleOnboardingForm, 'dateOfBirth', 'instructorUnder16') || (googleRole === 'INSTRUCTOR' && isGoogleUnder16))) {
            <div class="daisy-label mt-1">
              @if (hasFieldError(googleOnboardingForm, 'dateOfBirth', 'required')) {
              <span class="daisy-label-text-alt text-error">
                Date of Birth is required
              </span>
              } @else if (hasFieldError(googleOnboardingForm, 'dateOfBirth', 'instructorUnder16') || (googleRole === 'INSTRUCTOR' && isGoogleUnder16)) {
              <span class="daisy-label-text-alt text-error">
                Instructors must be at least 16 years of age
              </span>
              }
            </div>
            }
          </div>

          @if (googleRole !== 'INSTRUCTOR' && isGoogleUnder16) {
          <div class="daisy-form-control w-full">
            <label class="daisy-label">
              <span class="daisy-label-text font-medium">Parent/Guardian Email</span>
            </label>
            <input
              type="email"
              formControlName="parentEmail"
              placeholder="Parent/Guardian Email Address"
              class="daisy-input daisy-input-bordered w-full"
              [ngClass]="{
                'daisy-input-error':
                  isFieldInvalid(googleOnboardingForm, 'parentEmail') &&
                  (hasFieldError(googleOnboardingForm, 'parentEmail', 'required') || hasFieldError(googleOnboardingForm, 'parentEmail', 'email'))
              }"
            />
            @if (isFieldInvalid(googleOnboardingForm, 'parentEmail') && (hasFieldError(googleOnboardingForm, 'parentEmail', 'required') || hasFieldError(googleOnboardingForm, 'parentEmail', 'email'))) {
            <div class="daisy-label mt-1">
              @if (hasFieldError(googleOnboardingForm, 'parentEmail', 'required')) {
              <span class="daisy-label-text-alt text-error">
                Parent/Guardian email is required for users under 16
              </span>
              } @if (hasFieldError(googleOnboardingForm, 'parentEmail', 'email')) {
              <span class="daisy-label-text-alt text-error">
                Please enter a valid email address
              </span>
              }
            </div>
            }
          </div>
          <div class="daisy-alert daisy-alert-warning text-xs mt-2">
            <i class="fa-solid fa-triangle-exclamation"></i>
            <span>Since you are under 16, parental consent is required. An email will be sent to your parent/guardian to verify your account.</span>
          </div>
          }

          <div class="daisy-modal-action">
            <button
              type="button"
              (click)="showGoogleOnboarding = false"
              class="daisy-btn daisy-btn-ghost"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="daisy-btn daisy-btn-primary"
              [disabled]="googleOnboardingForm.invalid || isGoogleLoading"
            >
              @if (isGoogleLoading) {
              <span class="daisy-loading daisy-loading-spinner daisy-loading-sm"></span>
              } @else { Continue }
            </button>
          </div>
        </form>
      </div>
    </div>
    }
  </div>
</div>
